query GetFundGroups($page: Int, $limit: Int, $search: String, $sortBy: String) {
  fundGroups(page: $page, limit: $limit, search: $search, sortBy: $sortBy) {
    collection {
      id
      name
      salesforceId
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
